export default ({ theme: { colors } }) => ({
    padding: '0.5rem 0.75rem',
    textAlign: 'left',
    color: colors.blueGrey4,
    fontSize: '12px',
    letterSpacing: '0.1px',
    lineHeight: '20px',
});
